module.exports = __webpack_public_path__ + "static/media/Rcti_Indonesia.8da157a4.png";